export const esAgenda = {
  'agenda.description': 'Marca cada ocurrencia sin cambiar toda la serie recurrente.',
  'agenda.done': 'Hecho',
  'agenda.empty': 'No hay movimientos previstos en los próximos tres meses.',
  'agenda.notDone': 'No ocurrió',
  'agenda.pending': 'Pendiente',
  'agenda.projectionExcluded': 'Excluido de la proyección',
  'agenda.projectionIncluded': 'Incluido en la proyección',
  'agenda.title': '¿Esto pasó de verdad?',
} as const;

export const enAgenda: Record<keyof typeof esAgenda, string> = {
  'agenda.description': 'Mark each occurrence without changing the entire recurring series.',
  'agenda.done': 'Done',
  'agenda.empty': 'There are no planned movements in the next three months.',
  'agenda.notDone': 'Did not happen',
  'agenda.pending': 'Pending',
  'agenda.projectionExcluded': 'Excluded from projection',
  'agenda.projectionIncluded': 'Included in projection',
  'agenda.title': 'Did this really happen?',
};
